"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockImageProperty = exports.infoBlockImagePropertyDefinition = void 0;
exports.infoBlockImagePropertyDefinition = {
    view: {
        label: 'Image',
        hint: 'Image or illustration to provide visual context or make the information more engaging',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'info-block-image',
};
const isInfoBlockImageProperty = (prop) => {
    return prop.name === exports.infoBlockImagePropertyDefinition.name;
};
exports.isInfoBlockImageProperty = isInfoBlockImageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1pbWFnZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2staW1hZ2UucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsT0FBTztRQUNkLElBQUksRUFBRSx1RkFBdUY7S0FDOUY7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQztTQUNwQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxrQkFBa0I7Q0FDTyxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=